function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
import { isNot } from '../../_snowpack/pkg/styled-is.js';
import { lighten, darken, desaturate } from '../../_snowpack/pkg/polished.js';
import { colors } from './colors.js';
import LoadingSpinner from '../modules/loading-spinner.js';
const themes = {
  clean: {
    idle: `
      background: transparent;
      color: inherit;
      text-align: center;
    `
  },
  link: {
    idle: `
      background: transparent;
      color: ${colors.defrost};
      text-align: center;
    `
  },
  default: {
    idle: `
      background: #fff;
      color: ${colors.frostbite};
      text-align: left;
      border-radius: 40px;
      font-weight: 600;
      box-shadow: 2px 4px 10px rgba(0,0,0,0.1);
    `,
    hover: `
      background: ${darken(0.05, '#fff')};
      text-decoration: none;
      `,
    disabled: `
        background: ${desaturate(0.3, colors.glacier)}
      `
  },
  primary: {
    idle: `
      background: ${colors.tin};
      color: ${colors.density};
      text-align: center;
      border-radius: 8px;
    `,
    hover: `
      background: ${darken(0.05, colors.tin)};
    `,
    disabled: `
      background: ${desaturate(0.9, colors.tin)}
    `
  },
  secondary: {
    idle: `
      background: #fff;
      color: ${colors.density};
      text-align: center;
      border-radius:8px;
      box-shadow: 0px 2px 4px rgba(130, 138, 144, 0.15);
    `,
    hover: `
      background: ${darken(0.05, colors.frost)};
    `
  },
  danger: {
    idle: `
      background: ${lighten(0.1, colors.error)};
      color: #fff;
      text-align: center;
    `,
    hover: `
      background: ${lighten(0.05, colors.error)};
    `
  },
  regularparticle: {
    idle: `
      background-color: #D3CFF4;
      color: ${colors.frostbite};
      text-align: left;
      border-radius: 8px;
      font-weight: 500;
      box-shadow: 0px 2px 4px rgba(130, 138, 144, 0.15);
      `,
    hover: `
      background: ${darken(0.03, '#D3CFF4')};
      text-decoration: none;
      `,
    disabled: `
        background-color: #dddddd
      `
  },
  regularatom: {
    idle: `
      background-color: #FFEFD2;
      color: ${colors.frostbite};
      text-align: left;
      border-radius: 8px;
      font-weight: 500;
      box-shadow: 0px 2px 4px rgba(130, 138, 144, 0.15);
      `,
    hover: `
      background: ${darken(0.03, '#FFEFD2')};
      text-decoration: none;
      `,
    disabled: `
        background-color: #dddddd
      `
  },
  regularcrystal: {
    idle: `
      color: ${colors.frostbite};
      background: ${colors.glacier};
      text-align: left;
      border-radius: 8px;
      font-weight: 500;
      box-shadow: 0px 2px 4px rgba(130, 138, 144, 0.15);
      `,
    hover: `
      background: ${darken(0.1, colors.glacier)};
      text-decoration: none;
      `,
    disabled: `
        background-color: #dddddd
      `
  }
};
const linkThemes = {
  default: {
    spinnerColor: colors.frostbite,
    idle: `
      background: transparent;
      border-bottom: 2px solid #f47f98;
      text-decoration: none;
      text-align: left;
    `
  },
  danger: {
    spinnerColor: colors.error,
    idle: `
      background: transparent;
      border: none;
      text-decoration: none;
      text-decorationHover: underline;
      text-align: left;
      color: ${colors.error}
    `
  }
};
const dialogThemes = {
  __base: `
    min-width: 0;
    font-weight: 400;
    font-size: 16px;
  `,
  default: {
    idle: `
      color: ${colors.glacier};
      background: transparent;
      `,
    hover: `
        color: #fff;
        background: ${colors.glacier};

      `
  },
  secondary: {
    idle: `
      color: ${colors.error};
      background: transparent;
    `,
    hover: `
      color: #fff;
      background: ${colors.error};
    `
  }
};
const sizes = {
  compact: `
    padding: 0;
  `,
  tiny: `
    padding: 3px 7px;
    font-size: .8rem;
  `,
  small: `
    padding: 12px 13px;
    font-weight:600;
    font-size: var(--text-sm-font-size);
  `,
  medium: `
    padding: 15px 15px;
    min-width: 150px;
    font-weight: 600;
    font-size: var(--text-md-font-size);
  `,
  large: `
    padding: 15px 25px;
    font-size: 16px;
    font-weight: 600;
  `,
  xlarge: `
    padding: 20px 25px;
    font-size: 16px;
    font-weight: 600;
    min-width: 250px;
  `
};

function getTheme({
  themes,
  ...names
} = {}) {
  const keys = Object.keys(names);

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (names[key] && themes[key]) {
      // Delete the prop so that it not gets into the DOM
      delete names[key];
      return themes[key];
    }
  }

  return themes.default;
}

function getSize(sizeNames) {
  const keys = Object.keys(sizeNames);

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (sizeNames[key] && sizes[key]) {
      // Delete the prop so that it not gets into the DOM
      delete sizeNames[key];
      return sizes[key];
    }
  }

  return sizes.medium;
}

const ButtonInner = styled.span.withConfig({
  displayName: "buttons__ButtonInner",
  componentId: "sc-1s50ze3-0"
})(["position:relative;display:flex;align-items:center;justify-content:center;", ";", ";", ";white-space:nowrap;font-family:'Roboto';"], ({
  themeBase
}) => themeBase, p => p.size || '', p => p.theme ? p.theme.idle : '');
export const ButtonReset = styled.button.attrs(p => ({
  type: p.type || 'button'
})).withConfig({
  displayName: "buttons__ButtonReset",
  componentId: "sc-1s50ze3-1"
})(["display:inline-block;border-radius:0;border:none;padding:0;background:transparent;appearance:none;cursor:pointer;text-decoration:none;font-size:1rem;"]);
const ButtonOuter = styled(ButtonReset).withConfig({
  displayName: "buttons__ButtonOuter",
  componentId: "sc-1s50ze3-2"
})(["display:inline-block;position:relative;text-decoration:none;", ";&[href]:hover{text-decoration:none;}&:hover ", "{text-decoration:none;", ";}", ";&[disabled]{cursor:default;pointer-events:none;", "{", ";}}"], p => p.block ? 'width: 100%;' : '', ButtonInner, ({
  theme
}) => theme ? theme.hover : ``, isNot('noscaleonactive')`
    &:active:not([disabled]) ${ButtonInner} {
      transform: scale(0.95);
    }
  `, ButtonInner, ({
  theme
}) => theme ? theme.disabled : ``);
const ButtonText = styled.span.withConfig({
  displayName: "buttons__ButtonText",
  componentId: "sc-1s50ze3-3"
})(["position:relative;transition:opacity 100ms,transform 100ms;", ";"], isNot('shown')`
    opacity: 0;
    transform: scale(0.7);
  `);
const ButtonLoading = styled.span.withConfig({
  displayName: "buttons__ButtonLoading",
  componentId: "sc-1s50ze3-4"
})(["position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;transition:opacity 100ms,transform 100ms;display:flex;align-items:center;justify-content:center;opacity:1;transform:none;svg{height:1em;}"]);
const ButtonIcon = styled.span.withConfig({
  displayName: "buttons__ButtonIcon",
  componentId: "sc-1s50ze3-5"
})(["width:25px;margin-right:5px;> svg{display:block;}"]);
const Shadow = styled.div.withConfig({
  displayName: "buttons__Shadow",
  componentId: "sc-1s50ze3-6"
})(["height:20px;width:70%;background:", ";opacity:0.3;position:absolute;bottom:0;left:50%;transform:translateX(-50%);filter:blur(8px);z-index:-1;"], colors.frostbite);

function buttonCreator({
  buttonThemes
}) {
  return ({
    children,
    loading,
    block,
    icon: Icon,
    shadow,
    iconOnly,
    ...rest
  }) => {
    const theme = getTheme({
      themes: buttonThemes,
      ...rest
    });
    const size = getSize(rest);
    return /*#__PURE__*/React.createElement(ButtonOuter, _extends({}, rest, {
      theme: theme,
      block: block
    }), /*#__PURE__*/React.createElement(ButtonInner, {
      themeBase: buttonThemes.__base,
      theme: theme,
      size: size
    }, Icon && typeof Icon !== 'string' && /*#__PURE__*/React.createElement(ButtonIcon, null, /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement(ButtonText, {
      shown: !loading || iconOnly
    }, children), loading && /*#__PURE__*/React.createElement(ButtonLoading, null, /*#__PURE__*/React.createElement(LoadingSpinner, {
      color: theme.spinnerColor
    }))), shadow && /*#__PURE__*/React.createElement(Shadow, null));
  };
}

export const Button = buttonCreator({
  buttonThemes: themes
});
export const DialogButton = buttonCreator({
  buttonThemes: dialogThemes
});
export const LinkButton = buttonCreator({
  buttonThemes: linkThemes
});